module.exports = __webpack_public_path__ + "static/media/new-img8.b4f9f773.png";